var map = {
	"./Categories.svg": [
		354,
		13
	],
	"./Dishes.svg": [
		355,
		14
	],
	"./Menu.svg": [
		356,
		15
	],
	"./Restaurant.svg": [
		357,
		16
	],
	"./Tables.svg": [
		358,
		17
	],
	"./Waiters.svg": [
		359,
		18
	],
	"./enter.png": [
		167
	],
	"./man.svg": [
		360,
		19
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 431;
module.exports = webpackAsyncContext;